import {
  GET_EMAREGULATION,
  GET_EMAREGULATION_FAIL,
  GET_EMAREGULATION_SUCCESS,
  GET_EMAREGULATIONS,
  GET_EMAREGULATIONS_FAIL,
  GET_EMAREGULATIONS_SUCCESS,
  ADD_NEW_EMAREGULATION,
  ADD_EMAREGULATION_SUCCESS,
  ADD_EMAREGULATION_FAIL,
  UPDATE_EMAREGULATION,
  UPDATE_EMAREGULATION_SUCCESS,
  UPDATE_EMAREGULATION_FAIL,
  DELETE_EMAREGULATION,
  DELETE_EMAREGULATION_SUCCESS,
  DELETE_EMAREGULATION_FAIL,
  SET_STATE_EMAREGULATION,
  UPDATE_EMAREGULATION_STATUS
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_EMAREGULATION,
  payload: loading,
})

export const getEmaRegulations = ( params ) => ({
  type: GET_EMAREGULATIONS,
  payload: { params },
})

export const getEmaRegulationsSuccess = (emaRegulations, totalPages, currentPage) => ({
  type: GET_EMAREGULATIONS_SUCCESS,
  payload: { emaRegulations:emaRegulations, total:totalPages, currentPage:currentPage}
})

export const getEmaRegulationsFail = error => ({
  type: GET_EMAREGULATIONS_FAIL,
  payload: error,
})

export const addNewEmaRegulation = emaRegulation => ({
  type: ADD_NEW_EMAREGULATION,
  payload: emaRegulation,
})

export const addEmaRegulationSuccess = emaRegulation => ({
  type: ADD_EMAREGULATION_SUCCESS,
  payload: emaRegulation,
})  

export const addEmaRegulationFail = error => ({
  type: ADD_EMAREGULATION_FAIL,
  payload: error,
})

export const updateEmaRegulation = emaRegulation => ({
  type: UPDATE_EMAREGULATION,
  payload: emaRegulation,
})

export const updateEmaRegulationStatus = emaRegulation => ({
  type: UPDATE_EMAREGULATION_STATUS,
  payload: emaRegulation,
})

export const updateEmaRegulationSuccess = emaRegulation => ({
  type: UPDATE_EMAREGULATION_SUCCESS,
  payload: emaRegulation,
})

export const updateEmaRegulationFail = error => ({
  type: UPDATE_EMAREGULATION_FAIL,
  payload: error,
})

export const deleteEmaRegulation = emaRegulation => ({
  type: DELETE_EMAREGULATION,
  payload: emaRegulation,
})

export const deleteEmaRegulationSuccess = id => ({
  type: DELETE_EMAREGULATION_SUCCESS,
  id,
})

export const deleteEmaRegulationFail = error => ({
  type: DELETE_EMAREGULATION_FAIL,
  payload: error,
})

export const getEmaRegulation = () => ({
  type: GET_EMAREGULATION,
})

export const getEmaRegulationSuccess = emaRegulation => ({
  type: GET_EMAREGULATION_SUCCESS,
  payload: emaRegulation,
})

export const getEmaRegulationFail = error => ({
  type: GET_EMAREGULATION_FAIL,
  payload: error,
})
